/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-14T09:30:03.31
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialPayables,
	listFinancialPayablesInit,
	listFinancialPayablesByAuthorizations,
	deleteFinancialPayables
	
} from '@api/financial/FinancialPayables';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialPayables({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPayables(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPayablesByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPayablesByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialPayablesInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialPayablesInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialPayables({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialPayables({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
